/* Collection + search: live filters (Section Rendering API), sort, show more, grid size, sticky toolbar offset. */
(function () {
  var root = document.querySelector('[data-col]'); if (!root || root._c) return; root._c = 1;
  var sid = root.getAttribute('data-section');
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var busy = null;

  function withSection(url) { var u = new URL(url, location.origin); u.searchParams.set('section_id', sid); return u.toString(); }
  function cleanUrl(url) { var u = new URL(url, location.origin); u.searchParams.delete('section_id'); u.searchParams.delete('page'); return u.pathname + (u.search ? u.search : ''); }

  function swap(doc) {
    ['[data-col-count]', '[data-col-active]', '[data-col-filters]', '[data-col-more]', '[data-col-total]'].forEach(function (sel) {
      var a = $$(sel), b = doc.querySelectorAll(sel);
      a.forEach(function (el, i) { if (b[i]) el.innerHTML = b[i].innerHTML; });
    });
    var g = root.querySelector('[data-col-grid]'), ng = doc.querySelector('[data-col-grid]');
    if (g && ng) { ng.setAttribute('data-cols', g.getAttribute('data-cols') || '2'); g.replaceWith(ng); }
    var fc = document.querySelector('[data-col-fcount]'), nfc = doc.querySelector('[data-col-fcount]');
    if (fc && nfc) { fc.textContent = nfc.textContent; fc.hidden = nfc.hidden; }
    var so = root.querySelector('[data-col-sort]'), nso = doc.querySelector('[data-col-sort]');
    if (so && nso) so.value = nso.value;
    applyView(); if (window.CC && CC.init) CC.init();
  }

  function load(url) {
    if (busy) busy.abort && busy.abort();
    var ctl = window.AbortController ? new AbortController() : null; busy = ctl;
    root.classList.add('is-loading');
    return fetch(withSection(url), ctl ? { signal: ctl.signal } : {}).then(function (r) { return r.text(); }).then(function (h) {
      var doc = new DOMParser().parseFromString(h, 'text/html');
      swap(doc); history.replaceState({ col: 1 }, '', cleanUrl(url));
    }).catch(function (e) { if (e && e.name === 'AbortError') return; location.href = url; })
      .then(function () { root.classList.remove('is-loading'); });
  }

  function formUrl() {
    var form = document.querySelector('[data-col-form]'); var fd = new FormData(form), p = new URLSearchParams();
    fd.forEach(function (v, k) { if (v !== '') p.append(k, v); });
    return form.getAttribute('action') + '?' + p.toString();
  }

  var t;
  document.addEventListener('change', function (e) {
    if (e.target.closest('[data-col-form]')) { clearTimeout(t); t = setTimeout(function () { load(formUrl()); }, e.target.type === 'number' ? 500 : 0); }
    if (e.target.matches('[data-col-sort]')) {
      var r = document.querySelector('[data-col-form] input[name=sort_by][value="' + e.target.value + '"]'); if (r) r.checked = true;
      load(formUrl());
    }
  });
  document.addEventListener('submit', function (e) { if (e.target.closest('[data-col-form]')) { e.preventDefault(); load(formUrl()); } });
  document.addEventListener('click', function (e) {
    var a = e.target.closest('[data-col-link]'); if (a) { e.preventDefault(); load(a.href); return; }
    var n = e.target.closest('[data-col-next]');
    if (n) {
      e.preventDefault(); n.classList.add('is-loading');
      fetch(withSection(n.href)).then(function (r) { return r.text(); }).then(function (h) {
        var doc = new DOMParser().parseFromString(h, 'text/html');
        var grid = root.querySelector('[data-col-grid]');
        doc.querySelectorAll('[data-col-grid] > li:not(.col__cell--tile)').forEach(function (li) { grid.appendChild(li); });
        var m = root.querySelector('[data-col-more]'), nm = doc.querySelector('[data-col-more]'); if (m && nm) m.innerHTML = nm.innerHTML;
        if (window.CC && CC.init) CC.init();
      }).catch(function () { location.href = n.href; });
      return;
    }
    var v = e.target.closest('[data-col-view]'); if (v) { try { localStorage.setItem('cc-cols-' + (innerWidth < 990 ? 'm' : 'd'), v.getAttribute('data-col-view')); } catch (x) {} applyView(); }
  });

  function applyView() {
    var key = innerWidth < 990 ? 'm' : 'd', val = null;
    try { val = localStorage.getItem('cc-cols-' + key); } catch (x) {}
    val = val || (key === 'm' ? '2' : '4');
    var g = root.querySelector('[data-col-grid]'); if (g) g.setAttribute('data-cols', val);
    $$('[data-col-view]', root).forEach(function (b) { b.setAttribute('aria-pressed', b.getAttribute('data-col-view') === val); });
  }
  applyView();

  var bar = root.querySelector('[data-col-bar]'), hdr = document.querySelector('[data-header]'), raf = 0;
  function place() {
    raf = 0; if (!bar) return;
    var top = 0; if (hdr) { var r = hdr.getBoundingClientRect(); top = Math.max(0, r.bottom); }
    bar.style.setProperty('--col-top', top + 'px');
    bar.classList.toggle('is-stuck', bar.getBoundingClientRect().top <= top + 1);
  }
  addEventListener('scroll', function () { if (!raf) raf = requestAnimationFrame(place); }, { passive: true });
  addEventListener('resize', function () { applyView(); place(); });
  place();
})();
